import { createSlice } from '@reduxjs/toolkit'
import { getDisclaimer, getSupportInitiative, getVideo } from './monitorThunk';
import { Video } from '../../../interfaces/MediaAndContent';
import { Allies } from '../../../interfaces/Allies';

interface MonitorState {
    video: Video | null;
    loading: "idle" | "pending" | "succeeded" | "failed";
    allies: Allies[] | null;
    disclaimer: string | null;
}

const initialState: MonitorState = {
    loading: 'idle',
    video: null,
    allies: null,
    disclaimer: null
}

export const monitorSlice = createSlice({
    name: 'monitor',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getVideo.pending, (state) => {
            state.loading = "pending";
        });
        builder.addCase(getVideo.fulfilled, (state, action) => {
            state.loading = "succeeded";
            state.video = action.payload.video
        });
        builder.addCase(getVideo.rejected, (state) => {
            state.loading = "failed";
        });
        builder.addCase(getSupportInitiative.pending, (state) => {
            state.loading = "pending";
        });
        builder.addCase(getSupportInitiative.fulfilled, (state, action) => {
            state.loading = "succeeded";
            state.allies = action.payload.allies
        });
        builder.addCase(getSupportInitiative.rejected, (state) => {
            state.loading = "failed";
        });
        builder.addCase(getDisclaimer.pending, (state) => {
            state.loading = "pending";
        });
        builder.addCase(getDisclaimer.fulfilled, (state, action) => {
            state.loading = "succeeded";
            state.disclaimer = action.payload.disclaimer
        });
        builder.addCase(getDisclaimer.rejected, (state) => {
            state.loading = "failed";
        });
    },
})

export const { } = monitorSlice.actions;

export default monitorSlice.reducer;